import * as z from "zod";

const deliveryAnalyticsV2FilterOptions = z.object({
  carriers: z.array(z.string()),
  carrierServices: z.array(z.string()),
  states: z.array(z.string()),
  countries: z.array(z.string()),
});

export type DeliveryAnalyticsV2FilterOptions = z.infer<
  typeof deliveryAnalyticsV2FilterOptions
>;

export const getDeliveryAnalyticsV2FilterOptions = {
  name: "getDeliveryAnalyticsV2FilterOptions",
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: deliveryAnalyticsV2FilterOptions,
};
